export { default } from './index.vue'



// WEBPACK FOOTER //
// ./packages/dof-card-item/index.js